import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { useCallback } from 'react'
import ProgressBar from 'core/components/progress/ProgressBar'
import colors from 'core/themes/base/colors'
import Theme from 'core/themes/model'

interface Props {
  percent: number
}
const UsageProgressBar = ({ percent }) => {
  const classes = useStyles()
  const getProgressClass = useCallback(() => {
    if (percent < 40) return classes.progress
    if (percent < 70) return classes.progressMedium
    return classes.progressHigh
  }, [percent])

  return (
    <div data-testid="usage-progress-bar">
      <ProgressBar
        variant="progress"
        percent={percent}
        showPercent={false}
        className={clsx(classes.progressBar, getProgressClass())}
        color="success"
        width={'100%'}
      />
    </div>
  )
}
export default UsageProgressBar

const useStyles = makeStyles<Theme>((theme) => ({
  progressBar: {
    height: '-webkit-fill-available',
  },
  progressBarWidth: {
    width: '100%',
  },
  progress: {
    backgroundColor: colors.teal[200],
    border: `1px solid ${colors.teal[100]}`,
  },
  progressMedium: {
    backgroundColor: colors.beige[100],
    border: `1px solid ${colors.yellow[500]}`,
  },
  progressHigh: {
    backgroundColor: colors.palette[700],
    border: `1px solid ${colors.pink[800]}`,
  },
}))
